import React, { useEffect, useState } from 'react';
import CuadroDatos from '../UI/CuadroDatos.js';
import LinkPlus from '../UI/LinkPlus.js';
import * as CondicionLocalia from '../constantes/CondicionLocalia.js';
import * as Data from '../data/DataHistoriales.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './TotalesHistorial.module.css';

const TotalesHistorial = (props) => {
  const tipoHistorial = props.tipoHistorial;
  const competidor = props.competidor;
  const rival = props.rival;
  const filtro = props.filtro;
  const [totales, setTotales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  const idCompetidor = competidor?.id;
  const idRival = rival?.objeto?.id;
  const idCategoria = rival?.categoria?.id;
  const tipoRival = rival?.tipo;
  const tipoInternacional = rival?.tipoInternacional?.id;
  const pathURL = Data.PathBaseHistorial(tipoHistorial, idCompetidor, tipoRival);

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (pathURL) {
      if (pathURL) {
        const url = Data.URLTotalesPartidos(
          pathURL,
          idRival,
          filtro,
          idCategoria,
          tipoInternacional
        );
        fetchData(url, setTotales);
      }
    } else {
      setTotales([]);
    }
  }, [fetchData, pathURL, idRival, filtro, idCategoria, tipoInternacional]);

  const tituloCondicion = (condicion) => {
    switch (condicion) {
      case CondicionLocalia.TODOS: {
        return 'Total';
      }
      case CondicionLocalia.LOCAL: {
        return 'Local';
      }
      case CondicionLocalia.VISITANTE: {
        return 'Visitante';
      }
      case CondicionLocalia.NEUTRAL: {
        return 'Neutral';
      }
      default: {
        return '';
      }
    }
  };

  // Agrupar observaciones por idPartido para mobile
  const agruparObservacionesMobile = () => {
    const obsMap = new Map(); // Map de idPartido -> { observaciones: string, condiciones: Set<string> }

    totales.forEach((item) => {
      if (item.observaciones && item.observaciones.length > 0) {
        const condicionNombre = tituloCondicion(item.condicion);
        item.observaciones.forEach((obs) => {
          const key = obs.idPartido;
          if (!obsMap.has(key)) {
            obsMap.set(key, {
              idPartido: obs.idPartido,
              observaciones: obs.observaciones,
              condiciones: new Set(),
            });
          }
          obsMap.get(key).condiciones.add(condicionNombre);
        });
      }
    });

    return Array.from(obsMap.values());
  };

  return (
    <CuadroDatos titulo="Totales" isCargando={isCargando} errores={erroresGetLista}>
      {!isCargando && !erroresGetLista && (
        <React.Fragment>
          {totales.length > 0 ? (
            <div className={`${styles.containerMobile}`}>
              <table className={`${styles.tablaCompactaUnificada}`}>
                <thead>
                  <tr>
                    <th>Condición</th>
                    <th>PJ</th>
                    <th>PG</th>
                    <th>PE</th>
                    <th>PP</th>
                    <th>GF</th>
                    <th>GC</th>
                  </tr>
                </thead>
                <tbody>
                  {totales.map((item, index) => (
                    <tr key={index}>
                      <td className={`${styles.condicionNombre}`}>
                        {tituloCondicion(item.condicion)}
                      </td>
                      <td>{item.partidosJugados}</td>
                      <td>{item.partidosGanadosPropios}</td>
                      <td>{item.partidosEmpatados}</td>
                      <td>{item.partidosGanadosRival}</td>
                      <td>{item.golesPropios}</td>
                      <td>{item.golesRival}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {totales.length > 0 &&
                totales.some((item) => item.observaciones && item.observaciones.length > 0) && (
                  <div className={`${styles.observacionesMobile}`}>
                    {agruparObservacionesMobile().map((obs) => (
                      <div key={obs.idPartido} className={`${styles.obsItem}`}>
                        <LinkPlus to={`/partido/${obs.idPartido}`} adaptativo={true}>
                          (*)
                        </LinkPlus>
                        <span className={`${styles.obsCondiciones}`}>
                          [{Array.from(obs.condiciones).join(', ')}]
                        </span>
                        {' ' + obs.observaciones}
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ) : (
            <span className={`${styles.noPartidos}`}>No se enfrentaron</span>
          )}
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default TotalesHistorial;
